import React, { memo } from 'react';
import { length } from '~/services/util';
import PropTypes from 'prop-types';
import Pagination from '@components/@core/Pagination';
import * as ProgramsList from '@components/LibraryProgramsList';
import Button from '@components/@core/AnimatedButton';

const List = ({
    role = 1,
    data = {
        current_page: 0,
        data: [],
        last_page: 0,
    },
    onChange,
    onPer,
    onAdd,
    onToggle = () => {},
    onSelect,
    onModal = () => {},
}) => {
    const scorecards = data?.data ?? [];

    return (
        <div>
            <div className="d-flex py-2">
                <div className="d-flex-7 dsl-m12">Scorecard</div>
                <div className="d-flex-1 dsl-m12">Goals </div>
                <div className="d-flex-1 dsl-m12">Assigned</div>
            </div>
            {scorecards.length > 0 ? (
                scorecards.map((item, index) => (
                    <ProgramsList.ClosedList
                        key={`sc${index}`}
                        role={role}
                        name={item.title}
                        description={item.data.description}
                        modules={item.data.assigned}
                        quotas={item.data.quotas}
                        length={length(scorecards)}
                        type="scorecards"
                        published={item.published}
                        onToggle={() => onToggle(item.id)}
                        onChange={(e) => onSelect(e, item)}
                    />
                ))
            ) : (
                <p>No Scorecards available to display.</p>
            )}
            <Pagination current={data?.current_page} per={Number(data?.per_page)} pers={[10, 25, 50, 'all']} total={data?.last_page} onChange={onChange} onPer={onPer} />
            <div className="d-flex mt-2 jc-end">
                <Button type="high" onClick={onAdd}>
                    Add Scorecard
                </Button>
            </div>
        </div>
    );
};

List.propTypes = {
    role: PropTypes.number,
    data: PropTypes.shape({
        current_page: PropTypes.number,
        data: PropTypes.array,
        last_page: PropTypes.number,
    }),
    onChange: PropTypes.func,
    onPer: PropTypes.func,
    onAdd: PropTypes.func,
    onToggle: PropTypes.func,
    onSelect: PropTypes.func,
    onModal: PropTypes.func,
};

export default memo(List);
